'use client'

import {SplitWords} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {useRef} from 'react'

export interface ComingSoonTextProps {
	className?: string
	surtitle?: string;
	text: string;
	containerRef?
	letterMotion?: boolean
}

const TEXT_STAGGER = 0.05
const TEXT_DURATION = 0.3

export const ComingSoonText = ({className, surtitle, text, containerRef, letterMotion}: ComingSoonTextProps) => {
	const localRef = useRef<HTMLDivElement>(null)
	const setRefs = (el) => {
		localRef.current = el
		if (containerRef) containerRef.current = el
	}

	if (!text) return null

	return (
		<div className={cx(
			className,
			'text-grey-5 text-center',
			'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-2/3 lg:-translate-y-1/2',
		)}>
			<div
				ref={setRefs}
				className='flex flex-col justify-center items-center gap-24 lg:gap-40 opacity-0 invisible transform-gpu scale-150 translate-y-[calc(var(--screenHeightMin)/3)]'>
				{surtitle && <p className='text-10 leading-none uppercase font-medium tracking-widest'>{surtitle}</p>}
				<h2 className='font-serif span-w-11 md:span-w-6-wide lg:span-w-6 text-24 lg:text-48 leading-snug'>
					<SplitWords
						stagger={TEXT_STAGGER}
						isActive={letterMotion}
						duration={TEXT_DURATION}>
						{text}
					</SplitWords>
				</h2>
			</div>
		</div>
	)
}
